import { Checkbox, DatePicker, Descriptions } from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import { deleteLanding, getLanding } from '../../../api/landing.api';
import Button from '../../../components/Button';
import ErrorResponse from '../../../components/ErrorResponse';
import SimpleHeader from '../../../components/layout/SimpleHeader';
import Loader from '../../../components/Loader';
import ConfirmModal from '../../../components/modals/ConfirmModal';
import useAuth from '../../../hooks/useAuth';
import useAxios from '../../../hooks/useAxios';
import useNotification from '../../../hooks/useNotification';
import { IGetLanding } from '../../../models/landing.model';
import CustomTimePicker from '../../../components/CustomTimePicker';
import Radio from '../../../components/Radio';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store/rootReducer';

interface IMatch {
  landingCode: string;
}

const LandingRead = () => {
  const { t } = useTranslation();
  const { writeAuthYn } = useAuth();
  const match = useRouteMatch<IMatch>();
  const landingCode = Number(match.params.landingCode);
  const history = useHistory();
  const location = useLocation();

  const { successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios<IGetLanding>();
  const {
    data: submitRes,
    isLoading: submitIsLoading,
    error: submitError,
    execute: submitExecute,
  } = useAxios();

  const [confirmDeleteVisible, setConfirmDeleteVisible] = useState(false);
  const { commonCodes } = useSelector((state: RootState) => state.commonCode);
  // HP0010 학년 구분 (중3까지)
  const HP0010 = commonCodes.find((item) => item.commonCode === 'HP0010')?.detailCode;
  // HP0009 유입경로 구분
  const HP0009 = commonCodes.find((item) => item.commonCode === 'HP0009')?.detailCode;
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const campusList = campusData.filter(
    (item) =>
      item.campusKorName.includes('본사') === false &&
      item.campusKorName.includes('T') === false &&
      item.campusKorName.includes('시범') === false,
  );

  useEffect(() => {
    execute(getLanding(landingCode));
  }, [landingCode]);

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      successNotification(t('common.message.delete'));
      history.push(`/landing/page${location.search}`);
    }
  }, [submitRes, submitIsLoading]);

  const onDelete = () => {
    if (!landingCode) return;
    submitExecute(deleteLanding(landingCode));
  };

  // useEffect(() => {
  //   console.log(res);
  // }, [res]);

  return (
    <div className="content scrollbar">
      {isLoading || submitIsLoading ? <Loader /> : null}
      <ErrorResponse error={error} />
      <ErrorResponse error={submitError} />
      <SimpleHeader
        iconFile="icon-homepage-big.svg"
        parentMenu={t('homepage.landing.title1')}
        currentMenu={t('homepage.landing.title2')}
      />

      <div className='comm-table__area rowType'>
        <Descriptions bordered column={4} size="small">
          <Descriptions.Item label={t('landing.imagemanage.column4')} span={4}>
            {res?.data?.title}
          </Descriptions.Item>

          <Descriptions.Item label={t('landing.imagemanage.column8')} span={4}>
            {res?.data?.landingDesc}
          </Descriptions.Item>

          <Descriptions.Item label={t('landing.imagemanage.column9')} span={2}>
            <div className='comm-gap'>
              <div className="date-picker__area">
                <DatePicker
                  className="mr-1"
                  value={
                    res?.data?.startDate ? moment(res?.data?.startDate) : undefined
                  }
                  disabled
                />
              </div>
              <div className="time-picker__area">
                <CustomTimePicker
                  value={res?.data?.startTime ? res?.data?.startTime : ''}
                  onSelect={() => {}}
                  disabled
                />
              </div>
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t('landing.imagemanage.column10')} span={2}>
            <div className='comm-gap'>
              <div className="date-picker__area">
                <DatePicker
                  className="mr-1"
                  value={
                    res?.data?.endDate ? moment(res?.data?.endDate) : undefined
                  }
                  disabled
                />
              </div>
              <div className="time-picker__area">
                <CustomTimePicker
                  value={res?.data?.endTime ? res?.data?.endTime : ''}
                  onSelect={() => {}}
                  disabled
                />
              </div>
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t('landing.imagemanage.column18')} span={4}>
            <span className='comm-gap'>
              {campusList?.map((item: any) => {
                return (
                  <Checkbox
                    className=""
                    key={item.campusCode}
                    value={item.campusCode}
                    checked={res?.data?.campusCode
                      ?.split(',')
                      ?.includes(item.campusCode)}
                    disabled
                  >
                    {item.campusKorName} 캠퍼스
                  </Checkbox>
                );
              })}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={t('landing.imagemanage.column19')} span={4}>
            <span className='comm-gap'>
              {HP0010?.map((item: any) => {
                return (
                  <Checkbox
                    className=""
                    key={item.detailCode}
                    value={item.detailCode}
                    checked={res?.data?.gradeCode
                      ?.split(',')
                      ?.includes(item.detailCode)}
                    disabled
                  >
                    {item.korName}
                  </Checkbox>
                );
              })}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={t('landing.imagemanage.column20')} span={4}>
            <span className='comm-gap'>
              {HP0009?.map((item: any) => {
                return (
                  <Checkbox
                    className=""
                    key={item.detailCode}
                    value={item.detailCode}
                    checked={res?.data?.inflowCode
                      ?.split(',')
                      ?.includes(item.detailCode)}
                    disabled
                  >
                    {item.korName}
                  </Checkbox>
                );
              })}
            </span>
          </Descriptions.Item>
          <Descriptions.Item label={t('landing.imagemanage.column11')} span={4}>
            <a
              className="download-link"
              href={res?.data?.landingOgImageAttachFile?.fileLocation}
              download={res?.data?.landingOgImageAttachFile?.originalName}
            >
              {res?.data?.landingOgImageAttachFile?.originalName}
            </a>
          </Descriptions.Item>

          <Descriptions.Item label={t('landing.imagemanage.column12')} span={2}>
            <a
              className="download-link"
              href={res?.data?.component1PcAttachFile?.fileLocation}
              download={res?.data?.component1PcAttachFile?.originalName}
            >
              {res?.data?.component1PcAttachFile?.originalName}
            </a>
          </Descriptions.Item>
          <Descriptions.Item label={t('landing.imagemanage.column13')} span={2}>
            <div className="flex mb-2">
              <a
                className="download-link"
                href={res?.data?.component1MoAttachFile?.fileLocation}
                download={res?.data?.component1MoAttachFile?.originalName}
              >
                {res?.data?.component1MoAttachFile?.originalName}
              </a>
            </div>
          </Descriptions.Item>

          <Descriptions.Item label={t('landing.imagemanage.column14')} span={2}>
            <div className="flex mb-2">
              <a
                className="download-link"
                href={res?.data?.component2PcAttachFile?.fileLocation}
                download={res?.data?.component2PcAttachFile?.originalName}
              >
                {res?.data?.component2PcAttachFile?.originalName}
              </a>
            </div>
          </Descriptions.Item>
          <Descriptions.Item label={t('landing.imagemanage.column15')} span={2}>
            <div className="flex mb-2">
              <a
                className="download-link"
                href={res?.data?.component2MoAttachFile?.fileLocation}
                download={res?.data?.component2MoAttachFile?.originalName}
              >
                {res?.data?.component2MoAttachFile?.originalName}
              </a>
            </div>
          </Descriptions.Item>

          <Descriptions.Item label={'추가 링크'} span={2}>
            {res?.data?.landingLink}
          </Descriptions.Item>

          <Descriptions.Item label={'추가 링크 이미지'} span={2}>
            <div className="flex mb-2">
              <a
                className="download-link"
                href={res?.data?.landingLinkAttachFile?.fileLocation}
                download={res?.data?.landingLinkAttachFile?.originalName}
              >
                {res?.data?.landingLinkAttachFile?.originalName}
              </a>
            </div>
          </Descriptions.Item>

          <Descriptions.Item label={t('landing.imagemanage.column16')} span={4}>
            <Radio
              checked={res?.data?.openYn === 'Y'}
              onChange={() => {}}
              text="Y"
              disabled
            />
            <Radio
              className="ml-4"
              checked={res?.data?.openYn === 'N'}
              onChange={() => {}}
              text="N"
              disabled
            />
          </Descriptions.Item>
        </Descriptions>
      </div>

      <div className="comm-bx__between">
        <div className="comm-btn__area">
          <Button
            className="btn-basic gray-line"
            text={t('common.button.list')}
            onClick={() => history.push(`/landing/page${location.search}`)}
          />
        </div>
        <div className="comm-btn__area right">
          <Button
            className="btn-basic gray"
            text={t('common.button.delete')}
            onClick={() => setConfirmDeleteVisible(true)}
            writeAuthYn={writeAuthYn}
          />
          <Button
            className="btn-basic pink-line"
            text={t('common.button.edit')}
            onClick={() =>
              history.push(
                `/landing/page/${landingCode}/edit${location.search}`,
              )
            }
            writeAuthYn={writeAuthYn}
          />
        </div>
      </div>

      {confirmDeleteVisible && (
        <ConfirmModal
          visible={confirmDeleteVisible}
          setVisible={setConfirmDeleteVisible}
          onConfirm={onDelete}
          titleText={t('system.menu.title6')}
          messageText={t('system.menu.text3')}
          confirmText={t('common.button.delete')}
          cancelText={t('common.button.cancel')}
        />
      )}
    </div>
  );
};

export default LandingRead;
